var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "share-box" },
    [
      _c("c-header-return", {
        attrs: { isCustom: true, isBtnShow: true },
        scopedSlots: _vm._u([
          {
            key: "customTitle",
            fn: function () {
              return [
                _c("div", { staticClass: "mine-header flex flex-center-2" }, [
                  _c("h1", { staticClass: "mine-header-title" }, [
                    _vm._v("自建盲盒"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "mine-content" }, [
        _c(
          "div",
          {
            staticClass: "mine-user-banner",
            class: { "mine-user-banner-own": _vm.isCurrentUserShare },
          },
          [
            _vm.isCurrentUserShare
              ? [
                  _c(
                    "div",
                    { staticClass: "mine-user-avatar" },
                    [
                      _vm.userProfile.avatar
                        ? _c("el-image", {
                            attrs: {
                              src: _vm.$imgfilter(_vm.userProfile.avatar),
                              fit: "cover",
                            },
                          })
                        : _c(
                            "div",
                            { staticClass: "mine-user-avatar-placeholder" },
                            [
                              _c("span", { staticClass: "icon" }, [
                                _vm._v("?"),
                              ]),
                              _c("span", { staticClass: "badge" }, [
                                _vm._v(_vm._s(_vm.userProfile.level || 0)),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "mine-user-info" }, [
                    _c("p", { staticClass: "mine-user-nickname" }, [
                      _vm._v(_vm._s(_vm.userProfile.nickname || "--")),
                    ]),
                    _c("p", { staticClass: "mine-user-uid" }, [
                      _vm._v("UID " + _vm._s(_vm.userProfile.uid || "-")),
                    ]),
                  ]),
                  _c("div", { staticClass: "mine-user-banner-stats" }, [
                    _c("div", { staticClass: "mine-stat-box" }, [
                      _vm._v(
                        "创建盲盒: " +
                          _vm._s(_vm.profitInfoStats.totalCaseCount)
                      ),
                    ]),
                    _c("div", { staticClass: "mine-stat-box" }, [
                      _vm._v(
                        "已开出价值: " +
                          _vm._s(
                            _vm._f("conversion")(
                              _vm.profitInfoStats.totalOpenedValue
                            )
                          )
                      ),
                    ]),
                    _c("div", { staticClass: "mine-stat-box" }, [
                      _vm._v(
                        "已领取收益: " +
                          _vm._s(
                            _vm._f("conversion")(
                              _vm.profitInfoStats.totalReceivedProfit
                            )
                          )
                      ),
                    ]),
                    _c("div", { staticClass: "mine-stat-box fade" }, [
                      _vm._v(
                        "今日被开启: " +
                          _vm._s(_vm.profitInfoStats.todayOpenCount) +
                          "次"
                      ),
                    ]),
                    _c("div", { staticClass: "mine-stat-box fade" }, [
                      _vm._v(
                        "今日开出总价值: " +
                          _vm._s(
                            _vm._f("conversion")(
                              _vm.profitInfoStats.todayOpenedValue
                            )
                          )
                      ),
                    ]),
                    _c("div", { staticClass: "mine-stat-box fade" }, [
                      _vm._v(
                        "今日收益: " +
                          _vm._s(
                            _vm._f("conversion")(
                              _vm.profitInfoStats.todayProfit
                            )
                          )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "mine-user-own-extra" }, [
                    _c(
                      "div",
                      {
                        staticClass: "mine-intro-content",
                        on: { click: _vm.openBioEditModal },
                      },
                      [
                        _c("i", {
                          staticClass: "mine-intro-icon el-icon-edit",
                        }),
                        _c("span", { staticClass: "mine-intro-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.userProfile.intro ||
                                "欢迎来到我创建的盲盒...(自己介绍个人简介)"
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "mine-earnings-section" }, [
                      _c("span", { staticClass: "mine-earnings-label" }, [
                        _vm._v("待领取收益:"),
                      ]),
                      _c("span", { staticClass: "mine-earnings-value" }, [
                        _vm._v(
                          _vm._s(_vm._f("conversion")(_vm.displayEarnings))
                        ),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "mine-claim-btn",
                          attrs: { disabled: _vm.profitInfoLoading },
                          on: { click: _vm.handleClaimEarnings },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.profitInfoLoading ? "加载中..." : "领取收益"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "mine-user-avatar" },
                    [
                      _vm.userProfile.avatar
                        ? _c("el-image", {
                            attrs: {
                              src: _vm.$imgfilter(_vm.userProfile.avatar),
                              fit: "cover",
                            },
                          })
                        : _c(
                            "div",
                            { staticClass: "mine-user-avatar-placeholder" },
                            [
                              _c("span", { staticClass: "icon" }, [
                                _vm._v("?"),
                              ]),
                              _c("span", { staticClass: "badge" }, [
                                _vm._v(_vm._s(_vm.userProfile.level || 5)),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "mine-user-info" }, [
                    _c("p", { staticClass: "mine-user-nickname" }, [
                      _vm._v(_vm._s(_vm.userProfile.nickname || "--")),
                    ]),
                    _c("p", { staticClass: "mine-user-uid" }, [
                      _vm._v("UID " + _vm._s(_vm.userProfile.uid || "-")),
                    ]),
                    _c("p", { staticClass: "mine-user-intro" }, [
                      _vm._v(_vm._s(_vm.userProfile.intro || "")),
                    ]),
                  ]),
                  _c("div", { staticClass: "mine-user-banner-stats" }, [
                    _c("p", [
                      _vm._v("创建盲盒: " + _vm._s(_vm.userStats.createdCount)),
                    ]),
                    _c("p", [
                      _vm._v(
                        "已开出价值: " +
                          _vm._s(
                            _vm._f("conversion")(_vm.userStats.openedValue)
                          )
                      ),
                    ]),
                  ]),
                ],
          ],
          2
        ),
        _c("h2", { staticClass: "mine-section-title" }, [_vm._v("盲盒")]),
        _c(
          "div",
          { staticClass: "mine-tabs" },
          _vm._l(_vm.listTypeTabs, function (tab) {
            return _c(
              "div",
              {
                key: tab.value,
                staticClass: "mine-tab",
                class: { active: _vm.activeTab === tab.value },
                on: {
                  click: function ($event) {
                    _vm.activeTab = tab.value
                  },
                },
              },
              [
                tab.value == ""
                  ? _c("i", { staticClass: "el-icon-menu mine-tab-icon" })
                  : _vm._e(),
                _c("span", [_vm._v(_vm._s(tab.label))]),
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "mine-filters" }, [
          _c("div", { staticClass: "mine-filter-group" }, [
            _c("p", { staticClass: "mine-filter-label" }, [_vm._v("价格范围")]),
            _c(
              "div",
              { staticClass: "mine-filter-row" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "所有" },
                    model: {
                      value: _vm.priceRangeValue,
                      callback: function ($$v) {
                        _vm.priceRangeValue = $$v
                      },
                      expression: "priceRangeValue",
                    },
                  },
                  _vm._l(_vm.priceRangeList, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "默认" },
                    model: {
                      value: _vm.priceSortValue,
                      callback: function ($$v) {
                        _vm.priceSortValue = $$v
                      },
                      expression: "priceSortValue",
                    },
                  },
                  _vm._l(_vm.priceSortList, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "mine-filter-group" },
            [
              _c("p", { staticClass: "mine-filter-label" }, [
                _vm._v("排序范围"),
              ]),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "默认" },
                  model: {
                    value: _vm.sortRangeValue,
                    callback: function ($$v) {
                      _vm.sortRangeValue = $$v
                    },
                    expression: "sortRangeValue",
                  },
                },
                _vm._l(_vm.sortRangeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "mine-card-list" },
          _vm._l(_vm.displayList, function (item, index) {
            return _c(
              "div",
              { key: item.id || index, staticClass: "mine-card" },
              [
                item.status === 0
                  ? _c("div", { staticClass: "mine-card-review-mask" }, [
                      _vm._m(0, true),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "mine-card-share",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.onShare(item)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "21",
                          height: "21",
                          viewBox: "0 0 21 21",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M10.4859 0C4.69453 0 0 4.69453 0 10.4859C0 16.2773 4.69453 20.9719 10.4859 20.9719C16.2773 20.9719 20.9695 16.2773 20.9695 10.4859C20.9695 4.69453 16.275 0 10.4859 0ZM12.0469 15.0445V11.9437C12.0469 11.9437 6.67266 11.3461 3.53203 15.8203C3.53203 15.8203 4.52109 7.29141 12.0469 7.29141V4.19297L17.4633 9.61875L12.0469 15.0445Z",
                            fill: "#F5B844",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "mine-card-body" }, [
                  _c("div", { staticClass: "mine-card-left caseItem-item" }, [
                    _c(
                      "div",
                      { staticClass: "caseItem-casePic flex flex-center-1" },
                      [
                        _c("el-image", {
                          attrs: {
                            src: item.caseImgUrl
                              ? _vm.$imgfilter(item.caseImgUrl)
                              : "",
                            fit: "contain",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "caseItem-info flex flex-col flex-center-1",
                      },
                      [
                        _c("p", { staticClass: "title" }, [
                          _vm._v(_vm._s(item.name || "-")),
                        ]),
                        item.price != null
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "userInfo-price-item flex flex-ver",
                              },
                              [
                                _c("p", { staticClass: "userInfo-price-p" }, [
                                  _vm._v(
                                    _vm._s(_vm._f("conversion")(item.price))
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "caseItem-info-risk flex flex-ver" },
                          [
                            _vm._l(_vm.riskList, function (riskItem, ri) {
                              return _c(
                                "div",
                                {
                                  key: ri,
                                  staticClass:
                                    "caseItem-info-risk-item flex flex-col flex-center-1",
                                },
                                [
                                  _c("div", {
                                    staticClass: "schedule",
                                    style: {
                                      "background-color":
                                        _vm.itemRiskLevel(item) ===
                                        riskItem.value
                                          ? riskItem.activeBg
                                          : "rgba(255, 255, 255, 0.2)",
                                    },
                                  }),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "risk-p",
                                      class: {
                                        rishPActive:
                                          _vm.itemRiskLevel(item) ===
                                          riskItem.value,
                                      },
                                    },
                                    [_vm._v(_vm._s(riskItem.name))]
                                  ),
                                ]
                              )
                            }),
                            _c("div", {
                              staticClass: "current-risk-schedule",
                              style: { left: _vm.itemRiskSchedule(item) + "%" },
                            }),
                          ],
                          2
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "mine-card-extra" }, [
                      _c("span", [
                        _vm._v(
                          "Roll点: " +
                            _vm._s(item.rollMin != null ? item.rollMin : 500) +
                            "-" +
                            _vm._s(item.rollMax != null ? item.rollMax : 10000)
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          "概率" +
                            _vm._s(
                              item.probability != null ? item.probability : 5
                            ) +
                            "%"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mine-card-right" },
                    _vm._l(_vm.awardSections(item), function (section) {
                      return _c(
                        "div",
                        {
                          key: section.title,
                          staticClass: "mine-card-award-section",
                        },
                        [
                          _c("h3", { staticClass: "mine-card-award-title" }, [
                            _vm._v(_vm._s(section.title)),
                          ]),
                          _c(
                            "div",
                            { staticClass: "mine-card-award-list-wrap" },
                            [
                              section.list.length
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "mine-card-award-scroll-btn left",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "向左滚动",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.scrollAwardList($event, -1)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-arrow-left",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "mine-card-award-list" },
                                [
                                  !section.list.length
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "item mine-card-award-empty",
                                        },
                                        [
                                          _c("el-empty", {
                                            attrs: {
                                              "image-size": 48,
                                              description: "",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._l(
                                        section.list,
                                        function (award, ai) {
                                          return _c(
                                            "div",
                                            { key: ai, staticClass: "item" },
                                            [
                                              _c("c-award", {
                                                staticClass: "award",
                                                attrs: {
                                                  rarity: award.rarity,
                                                  picture: award.itemPic,
                                                  name: award.itemName,
                                                  price: award.sellPrice,
                                                  rate: award.dropRate,
                                                  width: "100%",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                ],
                                2
                              ),
                              section.list.length
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "mine-card-award-scroll-btn right",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "向右滚动",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.scrollAwardList($event, 1)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-arrow-right",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _c("div", { staticClass: "mine-card-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "mine-card-btn",
                      on: {
                        click: function ($event) {
                          return _vm.goOpen(item)
                        },
                      },
                    },
                    [_vm._v("去开箱")]
                  ),
                ]),
              ]
            )
          }),
          0
        ),
        _vm.memberIdFromRoute && _vm.hasMore
          ? _c("div", { staticClass: "mine-load-more" }, [
              _c(
                "button",
                {
                  staticClass: "mine-load-more-btn",
                  attrs: { type: "button", disabled: _vm.loadMoreLoading },
                  on: { click: _vm.loadMore },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.loadMoreLoading ? "加载中..." : "加载更多") +
                      " "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shareModalVisible,
              expression: "shareModalVisible",
            },
          ],
          staticClass: "mine-share-modal-mask",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.closeShareModal.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "mine-share-modal" }, [
            _c(
              "button",
              {
                staticClass: "mine-share-modal-close",
                attrs: { type: "button", "aria-label": "关闭" },
                on: { click: _vm.closeShareModal },
              },
              [_c("i", { staticClass: "el-icon-close" })]
            ),
            _c("h3", { staticClass: "mine-share-modal-title" }, [
              _vm._v(_vm._s(_vm.shareTitle)),
            ]),
            _c(
              "p",
              { ref: "shareDescP", staticClass: "mine-share-modal-desc" },
              [_vm._v("稀有道具、超高收益一起暴富~")]
            ),
            _c("div", { staticClass: "mine-share-modal-url" }, [
              _c("span", { staticClass: "mine-share-modal-url-label" }, [
                _vm._v("网址:"),
              ]),
              _c("input", {
                staticClass: "mine-share-modal-url-input",
                attrs: { type: "text", readonly: "" },
                domProps: { value: _vm.shareUrl },
              }),
              _c(
                "button",
                {
                  staticClass: "mine-share-modal-copy",
                  attrs: { type: "button" },
                  on: { click: _vm.copyShareUrl },
                },
                [
                  _c("i", { staticClass: "el-icon-document" }),
                  _c("span", [_vm._v("复制网址")]),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.bioEditModalVisible,
              expression: "bioEditModalVisible",
            },
          ],
          staticClass: "mine-bio-modal-mask",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.closeBioEditModal.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "mine-bio-modal" }, [
            _c(
              "button",
              {
                staticClass: "mine-bio-modal-close",
                attrs: { type: "button", "aria-label": "关闭" },
                on: { click: _vm.closeBioEditModal },
              },
              [_c("i", { staticClass: "el-icon-close" })]
            ),
            _c("h3", { staticClass: "mine-bio-modal-title" }, [
              _vm._v("编辑简介"),
            ]),
            _c(
              "div",
              { staticClass: "mine-bio-modal-content" },
              [
                _c("el-input", {
                  staticClass: "mine-bio-textarea",
                  attrs: {
                    type: "textarea",
                    rows: 6,
                    placeholder: "请输入个人简介",
                    maxlength: "200",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm.bioEditValue,
                    callback: function ($$v) {
                      _vm.bioEditValue = $$v
                    },
                    expression: "bioEditValue",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "mine-bio-modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "mine-bio-modal-btn cancel",
                  attrs: { type: "button" },
                  on: { click: _vm.closeBioEditModal },
                },
                [_vm._v("取消")]
              ),
              _c(
                "button",
                {
                  staticClass: "mine-bio-modal-btn confirm",
                  attrs: { type: "button", disabled: _vm.bioEditLoading },
                  on: { click: _vm.saveBio },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.bioEditLoading ? "保存中..." : "确认") +
                      " "
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mine-card-review-content" }, [
      _c("i", { staticClass: "el-icon-loading mine-card-review-icon" }),
      _c("span", { staticClass: "mine-card-review-text" }, [_vm._v("审核中")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }